import { AnalyseConstants } from '../../../_constants';

const initialState = { saveTeamStashLoading: true, stashedTeamData: ''};

export function saveStashTeamReducer(state = initialState, action) {
    switch (action.type) {
        case AnalyseConstants.REQUEST_SAVE_TEAM_STASH:
            return {
                saveTeamStashLoading: false,
                stashedTeamData: state.stashedTeamData
            };
        case AnalyseConstants.RECEIVE_SAVE_TEAM_STASH:
            return {
                saveTeamStashLoading: false,
                stashedTeamData: action.data
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/Analyse/saveTeam/saveStashTeam.reducer.js